$(document).ready(function () {
    var $sectionMilestones = $('.timeline-box');
    var $progressBar = $('.vertical-line');
    var $list = $sectionMilestones.find('.item');

    function isElementInViewport($el) {
        var rect = $el[0].getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function updateProgressBar() {
        if (isElementInViewport($sectionMilestones)) {
            var sectionTop = $sectionMilestones.offset().top;
            var sectionHeight = $sectionMilestones.outerHeight();
            var windowScrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();
            var windowMidPoint = windowScrollTop + windowHeight / 2;

            var progress = ((windowMidPoint - sectionTop) / sectionHeight) * 100;

            progress = Math.min(Math.max(progress, 0), 100);
            $progressBar.css('height', progress + '%');
        } else {
            $progressBar.css('height', '0');
        }
    }

    function updateScrolledItems() {
        var progressBarTop = $progressBar.offset().top;
        var progressBarBottom = progressBarTop + $progressBar.outerHeight();

        $list.each(function () {
            var $this = $(this);
            var itemTop = $this.offset().top;
            var itemBottom = itemTop + $this.outerHeight();


            if (progressBarBottom > itemTop && progressBarTop < itemBottom) {
                $this.addClass('scrolled');
            } else {
                $this.removeClass('scrolled');
            }
        });
    }

    $(window).on('scroll resize', function () {
        updateProgressBar();
        updateScrolledItems();
    });


    updateProgressBar();
    updateScrolledItems();
});
